import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import reducerGenerator from '../hierarchyAssignmentsEditor/reducerGenerator'

const hierarchyAssignmentsEditorReducer = reducerGenerator({
    actionTypes: ActionTypes
})

const initialState = {
    ...hierarchyAssignmentsEditorReducer.initialState,
    onlyActiveEntities: true
}

const editManagementAssignmentsEditor = handleActions({
    ...hierarchyAssignmentsEditorReducer.handlers,
    [ActionTypes.ONLY_ACTIVE_ENTITIES_SET]: (state, {payload: onlyActiveEntities}) => ({
        ...state,
        onlyActiveEntities
    }),
    [ActionTypes.ALL_EXISTING_AND_FUTURE_PROJECTS]: (state, {payload: futureProjectsAssigned}) => ({
        ...state,
        futureProjectsAssigned : futureProjectsAssigned
    }),
    [ActionTypes.ALL_EXISTING_AND_FUTURE_TASKS]: (state, {payload: futureTasksAssigned}) => ({
        ...state,
        futureTasksAssigned : futureTasksAssigned
    })
}, initialState)
export default editManagementAssignmentsEditor


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/managementAssignmentsEditor/reducer.js